import hubspotForm from '../../classes/hubspotForm.js';

document.querySelectorAll('[data-cl-hubspot-form]').forEach(
  form => new hubspotForm(form));
